const visibility = {
  all: 'Todos',
  internal: 'Internos',
  external: 'Contratados'
};

export default visibility;
